import { useState } from 'react';
import EnvironmentDigalog from '../helpers/EnvironmentDialog';
import { Environment } from '../networking/axios';
import styles from './HeaderLogo.module.css';

interface IHeaderLogoProps {
    isLarge: boolean
}

export default function HeaderLogo(props: IHeaderLogoProps) {
    const className = props.isLarge ? styles.logo_large : styles.logo_small;
    const src = props.isLarge ?
        "https://carsharing.s3.yandex.net/new-b2c-site/large_logo.png" :
        "https://carsharing.s3.yandex.net/new-b2c-site/small_logo_new.png";

    const [isDevPanelOpen, setIsDevPanelOpen] = useState(false);

    if (Environment.isTesting || Environment.isDev) {
        const selectedEnvironment = Environment.environmentName();

        return <div>
            <a href="https://yandex.ru/drive/" className={className}>
                <img src={src} />
            </a>
            <span style={{ color: "grey", cursor: "pointer", position: "absolute", "left": "220px", top: "30px" }} onClick={() => setIsDevPanelOpen(true)}>
                {selectedEnvironment}
            </span>
            {
                isDevPanelOpen && <EnvironmentDigalog onClose={() => setIsDevPanelOpen(false)} selected={selectedEnvironment} />
            }
        </div>
    } else {
        return <a href="https://yandex.ru/drive/" className={className}>
            <img src={src} />
        </a>
    }
}